export enum ServerDocTypeConstants {
  INTERNAL_PURCHASE_INVOICE = "INTERNAL_PURCHASE_INVOICE",
  INTERNAL_PURCHASE_RETURN = "INTERNAL_PURCHASE_RETURN",
  INTERNAL_SUPPLIER_RMA = "INTERNAL_SUPPLIER_RMA",
  INTERNAL_CUSTOMER_RMA = "INTERNAL_CUSTOMER_RMA",
  INTERNAL_CUSTOMER_CONSIGNMENT_IN = "INTERNAL_CUSTOMER_CONSIGNMENT_IN",
  INTERNAL_CUSTOMER_CONSIGNMENT_OUT = "INTERNAL_CUSTOMER_CONSIGNMENT_OUT",
  INTERNAL_PURCHASE_CREDIT_NOTE = "INTERNAL_PURCHASE_CREDIT_NOTE",
  INTERNAL_PURCHASE_DEBIT_NOTE = "INTERNAL_PURCHASE_DEBIT_NOTE",
  INTERNAL_SALES_INVOICE = "INTERNAL_SALES_INVOICE",
  INTERNAL_SALES_RETURN = "INTERNAL_SALES_RETURN",
  INTERNAL_SALES_CREDIT_NOTE = "INTERNAL_SALES_CREDIT_NOTE",
  INTERNAL_SALES_DEBIT_NOTE = "INTERNAL_SALES_DEBIT_NOTE",
  INTERNAL_SALARY_ADVICE = "INTERNAL_SALARY_ADVICE",
  INTERNAL_SALARY_PAYMENT_VOUCHER = "INTERNAL_SALARY_PAYMENT_VOUCHER",
  INTERNAL_PURCHASE_GOODS_RECEIVED_NOTE = "INTERNAL_PURCHASE_GOODS_RECEIVED_NOTE",
  INTERNAL_PURCHASE_GOODS_ISSUED_NOTE = "INTERNAL_PURCHASE_GOODS_ISSUED_NOTE",
  INTERNAL_SALES_GOODS_RECEIVED_NOTE = "INTERNAL_SALES_GOODS_RECEIVED_NOTE",
  INTERNAL_SALES_GOODS_ISSUED_NOTE = "INTERNAL_SALES_GOODS_ISSUED_NOTE",
  INTERNAL_OUTBOUND_STOCK_TRANSFER = "INTERNAL_OUTBOUND_STOCK_TRANSFER",
  INTERNAL_INBOUND_STOCK_TRANSFER = "INTERNAL_INBOUND_STOCK_TRANSFER",
  INTERNAL_STOCK_ADJUSTMENT = "INTERNAL_STOCK_ADJUSTMENT",
  INTERNAL_PAYMENT_VOUCHER = "INTERNAL_PAYMENT_VOUCHER",
  INTERNAL_RECEIPT_VOUCHER = "INTERNAL_RECEIPT_VOUCHER",
  INTERNAL_PURCHASE_ORDER = "INTERNAL_PURCHASE_ORDER",
  INTERNAL_SALES_QUOTATION = "INTERNAL_SALES_QUOTATION",
  INTERNAL_SALES_NEG_QUOTE = "INTERNAL_SALES_NEG_QUOTE",
  INTERNAL_JOB_ORDER = "INTERNAL_JOB_ORDER",
  INTERNAL_CUSTOM = "INTERNAL_CUSTOM",
  INTERNAL_PICKING_PACKING = "INTERNAL_PICKING_PACKING",
  INTERNAL_STOCK_ALLOCATION = "INTERNAL_STOCK_ALLOCATION",
  INTERNAL_STOCK_TRANSFER_NOTE = "INTERNAL_STOCK_TRANSFER_NOTE",
  INTERNAL_SALES_RMA = "INTERNAL_SALES_RMA",
  INTERNAL_PURCHASE_RMA = "INTERNAL_PURCHASE_RMA",
  INTERNAL_OUTBOUND_DELIVERY_ORDER = "INTERNAL_OUTBOUND_DELIVERY_ORDER",
  INTERNAL_GOODS_DISPATCH_NOTE = "INTERNAL_GOODS_DISPATCH_NOTE",
  INTERNAL_GOODS_DELIVERY_NOTE = "INTERNAL_GOODS_DELIVERY_NOTE",
  INTERNAL_SHOPPING_CART = "INTERNAL_SHOPPING_CART",
  INTERNAL_ABANDONED_CART = "INTERNAL_ABANDONED_CART",
  INTERNAL_PRODUCTION_ORDER = "INTERNAL_PRODUCTION_ORDER",
  INTERNAL_PLANNED_ORDER = "INTERNAL_PLANNED_ORDER",
  INTERNAL_PURCHASE_CONTRACT = "INTERNAL_PURCHASE_CONTRACT",
  INTERNAL_SALES_CONTRACT = "INTERNAL_SALES_CONTRACT",
  INTERNAL_SALES_PROFORMA_INVOICE = "INTERNAL_SALES_PROFORMA_INVOICE",
  INTERNAL_CONSIGNEE_CONSIGNMENT = "INTERNAL_CONSIGNEE_CONSIGNMENT",
  INTERNAL_CONSIGNOR_CONSIGNMENT = "INTERNAL_CONSIGNOR_CONSIGNMENT",
  INTERNAL_JOBSHEET = "INTERNAL_JOBSHEET",
  INTERNAL_PACKING_ORDER = "INTERNAL_PACKING_ORDER",
  INTERNAL_PURCHASE_QUOTATION = "INTERNAL_PURCHASE_QUOTATION",
  INTERNAL_SALES_CASHBILL = "INTERNAL_SALES_CASHBILL",
  INTERNAL_SUPPLIER_CONSIGNMENT_IN = "INTERNAL_SUPPLIER_CONSIGNMENT_IN",
  INTERNAL_SUPPLIER_CONSIGNMENT_OUT = "INTERNAL_SUPPLIER_CONSIGNMENT_OUT",
  INTERNAL_CONSIGNEE_GOODS_ISSUE_NOTE = "INTERNAL_CONSIGNEE_GOODS_ISSUE_NOTE",
  INTERNAL_CONSIGNEE_GOODS_RECEIVED_NOTE = "INTERNAL_CONSIGNEE_GOODS_RECEIVED_NOTE",
  INTERNAL_CONSIGNOR_GOODS_ISSUE_NOTE = "INTERNAL_CONSIGNOR_GOODS_ISSUE_NOTE",
  INTERNAL_CONSIGNOR_GOODS_RECEIVED_NOTE = "INTERNAL_CONSIGNOR_GOODS_RECEIVED_NOTE",
  INTERNAL_PURCHASE_REQUISITION = "INTERNAL_PURCHASE_REQUISITION",
  INTERNAL_SALES_INQUIRY = "INTERNAL_SALES_INQUIRY",
  INTERNAL_SALES_ORDER = "INTERNAL_SALES_ORDER",
  INTERNAL_OUTBOUND_DELIVERY_NOTE = "INTERNAL_OUTBOUND_DELIVERY_NOTE",
  INTERNAL_INBOUND_DELIVERY_ORDER = "INTERNAL_INBOUND_DELIVERY_ORDER",
  INTERNAL_MEMBERSHIP_POINT_REWARD = "INTERNAL_MEMBERSHIP_POINT_REWARD",
  INTERNAL_MEMBERSHIP_POINT_REDEEM = "INTERNAL_MEMBERSHIP_POINT_REDEEM",
  TMPL_INTERNAL_SALES_INVOICE = "TMPL_INTERNAL_SALES_INVOICE",
  CUSTOM_MS_ESD_ORDER = "CUSTOM_MS_ESD_ORDER",
  CUSTOM_DOCUMENT = "CUSTOM_DOCUMENT",
  SUPPLIER_OUTBOUND_DELIVERY_NOTE = "SUPPLIER_OUTBOUND_DELIVERY_NOTE",
  SUPPLIER_INBOUND_DELIVERY_NOTE = "SUPPLIER_INBOUND_DELIVERY_NOTE",
  SUPPLIER_SALES_ORDER = "SUPPLIER_SALES_ORDER",
  SUPPLIER_SALES_INVOICE = "SUPPLIER_SALES_INVOICE",
  SUPPLIER_SALES_RETURN = "SUPPLIER_SALES_RETURN",
  SUPPLIER_SALES_CREDIT_NOTE = "SUPPLIER_SALES_CREDIT_NOTE",
  SUPPLIER_SALES_DEBIT_NOTE = "SUPPLIER_SALES_DEBIT_NOTE",
  SUPPLIER_SALES_QUOTATION = "SUPPLIER_SALES_QUOTATION",
  CUSTOMER_PURCHASE_ORDER = "CUSTOMER_PURCHASE_ORDER",
  CUSTOMER_PURCHASE_INVOICE = "CUSTOMER_PURCHASE_INVOICE",
  CUSTOMER_PURCHASE_GOODS_RECEIVED_NOTE = "CUSTOMER_PURCHASE_GOODS_RECEIVED_NOTE",
  CUSTOMER_PURCHASE_GOODS_RETURNED_NOTE = "CUSTOMER_PURCHASE_GOODS_RETURNED_NOTE",
  CUSTOMER_PURCHASE_CREDIT_NOTE = "CUSTOMER_PURCHASE_CREDIT_NOTE",
  CUSTOMER_PURCHASE_DEBIT_NOTE = "CUSTOMER_PURCHASE_DEBIT_NOTE",
  EXTERNAL_SUPPLIER_SALES_ORDER = "EXTERNAL_SUPPLIER_SALES_ORDER",
  EXTERNAL_SUPPLIER_SALES_INVOICE = "EXTERNAL_SUPPLIER_SALES_INVOICE",
  EXTERNAL_SUPPLIER_SALES_RETURN = "EXTERNAL_SUPPLIER_SALES_RETURN",
  EXTERNAL_SUPPLIER_SALES_CREDIT_NOTE = "EXTERNAL_SUPPLIER_SALES_CREDIT_NOTE",
  EXTERNAL_SUPPLIER_SALES_DEBIT_NOTE = "EXTERNAL_SUPPLIER_SALES_DEBIT_NOTE",
  EXTERNAL_SALES_GOODS_RECEIVED_NOTE = "EXTERNAL_SALES_GOODS_RECEIVED_NOTE",
  EXTERNAL_SALES_GOODS_ISSUED_NOTE = "EXTERNAL_SALES_GOODS_ISSUED_NOTE",
  INTERNAL_OUTBOUND_STOCK_REQUISITION = "INTERNAL_OUTBOUND_STOCK_REQUISITION",
  INTERNAL_INBOUND_STOCK_REQUISITION = "INTERNAL_INBOUND_STOCK_REQUISITION",
  INTERNAL_STOCK_REQUISITION = "INTERNAL_STOCK_REQUISITION",
  INTERNAL_BLANKET_PURCHASE_ORDER = "INTERNAL_BLANKET_PURCHASE_ORDER",
  INTERNAL_SALES_INVOICE_NO_STOCK_OUT = "INTERNAL_SALES_INVOICE_NO_STOCK_OUT",
  INTERNAL_PURCHASE_INVOICE_NO_STOCK_IN = "INTERNAL_PURCHASE_INVOICE_NO_STOCK_IN",
  INTERNAL_PURCHASE_CONSIGNMENT_ORDER = "INTERNAL_PURCHASE_CONSIGNMENT_ORDER",
  INTERNAL_PURCHASE_CONSIGNMENT_GRN = "INTERNAL_PURCHASE_CONSIGNMENT_GRN",
  INTERNAL_PURCHASE_CONSIGNMENT_INVOICE = "INTERNAL_PURCHASE_CONSIGNMENT_INVOICE",
  INTERNAL_PURCHASE_CONSIGNMENT_RETURN = "INTERNAL_PURCHASE_CONSIGNMENT_RETURN",
  INTERNAL_SALES_REFUND_NOTE = "INTERNAL_SALES_REFUND_NOTE",
  INTERNAL_PURCHASE_SELF_BILLED_INVOICE = "INTERNAL_PURCHASE_SELF_BILLED_INVOICE",
  INTERNAL_PURCHASE_GRN_STOCK_IN = "INTERNAL_PURCHASE_GRN_STOCK_IN",
}
